import React from 'react';
import { createRoot } from 'react-dom/client';
import SiteMapApp from './SiteMapApp';
const el = document.getElementById('root');
if (el) createRoot(el).render(<React.StrictMode><SiteMapApp /></React.StrictMode>);
